module.exports = __webpack_public_path__ + "static/media/documentImage.93f8e27b.jpeg";